import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';
import { styles as dualOccStyles } from 'src/pages/occupant-details/styles';

const { theme, isHosTheme } = getTheme();

export const styles = {
    ...dualOccStyles,
    wrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '30px',
    }),
    inputGroupWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: { flexDirection: 'row' },
    }),
    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',
        marginTop: '30px',
        textTransform: 'uppercase',
    }),
    userMessage: css({ marginTop: '-20px' }),
};

export const amendSummaryStyles = {
    layout: css({
        display: 'flex',
        width: '100%',
        height: '100%',
        padding: '60px 20px 0 20px',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        [theme.breakpoints.up('lg')]: {
            padding: '80px 20px 0 20px',
        },
    }),
    wrapper: css({
        display: 'flex',
        maxWidth: '570px',
        height: '100%',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        rowGap: '40px',
        [theme.breakpoints.up('lg')]: {
            minWidth: '570px',
        },
    }),
    title: css({
        color: theme.palette.common.black,
    }),
    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'center',
        margin: '30px 0 40px 0',
        order: 1,
        [theme.breakpoints.up('lg')]: {
            order: 2,
            width: '190px',
        },
    }),
};

export const amendBookingDetailsStyles = {
    activeIcon: css({
        border: `1px solid ${
            isHosTheme ? theme.palette.secondary.dark : theme.palette.text.secondary
        }`,
        cursor: 'pointer',
    }),

    disabledIcon: css({
        border: `1px solid ${theme.palette.text.disabled}`,
        cursor: 'not-allowed',
    }),

    bookingLengthWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
    }),

    bookingLength: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),

    instalmentPlanWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
    }),

    instalmentPlan: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),

    wrapper: css({
        width: '100%',
        border: isHosTheme
            ? `0.5px solid ${theme.palette.secondary.dark}`
            : `1px solid ${theme.palette.grey[600]}`,
        padding: '25px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        rowGap: '40px',
        boxSizing: 'border-box',

        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
        }),
    }),
};
